import { render } from "./GrecaptchaText.vue?vue&type=template&id=d4045530"
import script from "./GrecaptchaText.vue?vue&type=script&lang=js"
export * from "./GrecaptchaText.vue?vue&type=script&lang=js"

import "./GrecaptchaText.vue?vue&type=style&index=0&id=d4045530&lang=css"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__